var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1757_329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#EEEEEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1757_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.925 8.55C3.35 8.225 3.825 7.96875 4.35 7.78125C4.875 7.59375 5.425 7.5 6 7.5C6.575 7.5 7.125 7.59375 7.65 7.78125C8.175 7.96875 8.65 8.225 9.075 8.55C9.36667 8.20834 9.59375 7.82084 9.75625 7.3875C9.91875 6.95417 10 6.49167 10 6C10 4.89167 9.61042 3.94792 8.83125 3.16875C8.05208 2.38959 7.10833 2 6 2C4.89167 2 3.94792 2.38959 3.16875 3.16875C2.38958 3.94792 2 4.89167 2 6C2 6.49167 2.08125 6.95417 2.24375 7.3875C2.40625 7.82084 2.63333 8.20834 2.925 8.55ZM6 6.5C5.50833 6.5 5.09375 6.33125 4.75625 5.99375C4.41875 5.65625 4.25 5.24167 4.25 4.75C4.25 4.25834 4.41875 3.84375 4.75625 3.50625C5.09375 3.16875 5.50833 3 6 3C6.49167 3 6.90625 3.16875 7.24375 3.50625C7.58125 3.84375 7.75 4.25834 7.75 4.75C7.75 5.24167 7.58125 5.65625 7.24375 5.99375C6.90625 6.33125 6.49167 6.5 6 6.5ZM6 11C5.30833 11 4.65833 10.8688 4.05 10.6063C3.44167 10.3438 2.9125 9.9875 2.4625 9.5375C2.0125 9.0875 1.65625 8.55834 1.39375 7.95C1.13125 7.34167 1 6.69167 1 6C1 5.30834 1.13125 4.65834 1.39375 4.05C1.65625 3.44167 2.0125 2.9125 2.4625 2.4625C2.9125 2.0125 3.44167 1.65625 4.05 1.39375C4.65833 1.13125 5.30833 1 6 1C6.69167 1 7.34167 1.13125 7.95 1.39375C8.55833 1.65625 9.0875 2.0125 9.5375 2.4625C9.9875 2.9125 10.3438 3.44167 10.6062 4.05C10.8687 4.65834 11 5.30834 11 6C11 6.69167 10.8687 7.34167 10.6062 7.95C10.3438 8.55834 9.9875 9.0875 9.5375 9.5375C9.0875 9.9875 8.55833 10.3438 7.95 10.6063C7.34167 10.8688 6.69167 11 6 11Z",
    fill: "#6B3CE1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.a51bd9387f47bda5d7bf2b546b8f5b47.svg";
export { ForwardRef as ReactComponent };